module.exports = __webpack_public_path__ + "img/2b.54304dbd.jpg";